import { render, staticRenderFns } from "./SchoolFacialEditModal.vue?vue&type=template&id=12351600&scoped=true&"
import script from "./SchoolFacialEditModal.vue?vue&type=script&lang=js&"
export * from "./SchoolFacialEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12351600",
  null
  
)

export default component.exports